import TableIconLabel from '@components/table-icon-label/table-icon-label.component'
import { withTransaction } from '@elastic/apm-rum-react'
import { BorderWithIcon, Button, Environment, User, localForageHelper, onEnvironmentChange, onUserChange } from '@hub/shared'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SubscriptionLike } from 'rxjs'
import './analytics.page.scoped.scss'

interface Props {
  idProfile: string | number
}

const AnalyticsPageComponent = ({ idProfile }: Props) => {
  const onUserChangeSubscription = useRef<SubscriptionLike | undefined>(undefined)
  const onEnviromentChange = useRef<SubscriptionLike | undefined>(undefined)
  const [user, setUser] = useState<User | null>(null)
  const [authUrl, setAuthUrl] = useState('')

  const [t] = useTranslation('analyticsMediaKitPage')
  const posts = [
    {
      label: t('likes'),
      icon: 'fa-regular fa-heart',
    },
    {
      label: t('comments'),
      icon: 'fa-regular fa-comment',
    },
    {
      label: t('bookmarks'),
      icon: 'fa-regular fa-bookmark',
    },
    {
      label: t('prints'),
      icon: 'fa-regular fa-eye',
    },
    {
      label: t('reach'),
      icon: 'fa-regular fa-bullhorn',
    },
    {
      label: t('engagementRate'),
      icon: 'fa-regular fa-badge-percent',
      tooltip: t('engagementRateTooltipStories'),
    },
  ]

  const stories = [
    {
      label: t('replies'),
      icon: 'fa-regular fa-reply',
    },
    {
      label: t('tapsBack'),
      icon: 'fa-regular fa-hand-back-point-left',
    },
    {
      label: t('prints'),
      icon: 'fa-regular fa-eye',
    },
    {
      label: t('reach'),
      icon: 'fa-regular fa-bullhorn',
    },
    {
      label: t('engagementRate'),
      icon: 'fa-regular fa-badge-percent',
      tooltip: t('engagementRateTooltipPosts'),
    },
  ]

  const reels = [
    {
      label: t('likes'),
      icon: 'fa-regular fa-heart',
    },
    {
      label: t('comments'),
      icon: 'fa-regular fa-comment',
    },
    {
      label: t('bookmarks'),
      icon: 'fa-regular fa-bookmark',
    },
    {
      label: t('prints'),
      icon: 'fa-regular fa-eye',
    },
    {
      label: t('reach'),
      icon: 'fa-regular fa-bullhorn',
    },
    {
      label: t('engagementRate'),
      icon: 'fa-regular fa-badge-percent',
      tooltip: t('engagementRateTooltipPosts'),
    },
  ]

  const audienceData = [
    {
      label: t('followers'),
      icon: 'fa-regular fa-user-group',
    },
    {
      label: t('audienceAge'),
      icon: 'fa-regular fa-bars-sort',
    },
    {
      label: t('cities'),
      icon: 'fa-regular fa-bars-sort',
    },
  ]

  const onRenewToken = async () => {
    await localForageHelper.setItem('actions', { action: 'renew', idProfile })
    window.location.href = `${authUrl}/facebook?squid-callback=${window.location.href}`
  }

  useEffect(() => {
    onUserChangeSubscription.current = onUserChange.subscribe(async (newUser: User) => {
      setUser(newUser)
    })
  }, [])

  useEffect(() => {
    onEnviromentChange.current = onEnvironmentChange.subscribe((environment: Environment) => {
      setAuthUrl(environment?.squidApis?.proxy)
    })

    return () => onEnviromentChange?.current?.unsubscribe()
  }, [])

  const hasTokenValid = useMemo(() => {
    const provider = user?.statusProviders?.instagram?.find((provider) => provider.id === idProfile)
    return provider ? !provider.tokenExpired : false
  }, [user, idProfile])

  return (
    <div className="analytics-media-kit-page">
      <h5>{t('analyticsDataTitle')}</h5>

      <div className="analytics-posts">
        <TableIconLabel title={t('posts')} data={posts}></TableIconLabel>
        <TableIconLabel title={t('stories')} data={stories}></TableIconLabel>
        <TableIconLabel title={t('reels')} data={reels}></TableIconLabel>
      </div>

      <TableIconLabel title={t('analyticsDataTitle')} data={audienceData}></TableIconLabel>

      <BorderWithIcon>
        <h5>{t('rememberBoxTitle')}</h5>
        <p className="mb-4">{t('rememberBoxLabel')}</p>

        <div className="remember-box-info">
          <i className="mr-3 fa-solid fa-check-circle green"></i>
          <p>{t('rememberBoxCheck')}</p>
        </div>

        <div className="remember-box-info mb-4">
          <i
            className={`mr-3 ${hasTokenValid ? 'fa-solid fa-check-circle' : 'fa-solid fa-exclamation-triangle'} ${
              hasTokenValid ? 'green' : 'gold'
            }`}
          ></i>
          <p>{t('rememberBoxAlert')}</p>
        </div>

        {!hasTokenValid && (
          <Button style={{ width: '100%', marginBottom: '1rem' }} onClick={() => onRenewToken()}>
            <i className="fa-solid fa-triangle-exclamation" style={{ marginRight: '0.5rem' }}></i>
            {t('toValidToken')}
          </Button>
        )}
      </BorderWithIcon>
    </div>
  )
}

export default withTransaction('AnalyticsPageComponent', 'component')(AnalyticsPageComponent)
